import { Encoder } from '@everyboard/lib';
import { Player, PlayerOrNone } from '../../jscaip/Player';
export class EncapsulePiece {
    size;
    owner;
    static encoder = Encoder.tuple([Encoder.identity(), Player.encoder], (piece) => [piece.size, piece.owner], (value) => EncapsulePiece.ofSizeAndPlayer(value[0], value[1]));
    static NONE = new EncapsulePiece(0, PlayerOrNone.NONE);
    static ofSizeAndPlayer(size, player) {
        if (player.isNone() || size === 0) {
            return EncapsulePiece.NONE;
        }
        else {
            return new EncapsulePiece(size, player);
        }
    }
    constructor(size, owner) {
        this.size = size;
        this.owner = owner;
    }
    getPlayer() {
        return this.owner;
    }
    getSize() {
        return this.size;
    }
    belongsTo(player) {
        return this.getPlayer() === player;
    }
    equals(other) {
        return this.size === other.size &&
            this.owner.equals(other.owner);
    }
    toString() {
        return 'size-' + this.size + '-' + this.getPlayer().toString();
    }
}
